import { render, staticRenderFns } from "./FrequencySelectInput.vue?vue&type=template&id=4458b482"
import script from "./FrequencySelectInput.vue?vue&type=script&lang=ts"
export * from "./FrequencySelectInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports